import _ from "lodash";
import queryString from "query-string";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { PROPERTY_TYPE } from "../../common/constant";
import { useQuantity } from "../../hooks/useQuantity";
import { addProductToCart } from "../../redux/reducers/slice/cart";
import {
  addCompareProduct,
  removeCompareProduct,
  selectCompareProducts,
} from "../../redux/reducers/slice/common";
import {
  checkGrandOpeningPromotion,
  checkInCompareList,
  getSlugByLanguage,
} from "../../shared/helpers";
import NotificationAddToCartSuccess from "../notification";
import ProductItemComponent from "../productItem";
import WishButton from "../wishButton";
import "./style.scss";

const FilterProductSpecItem = (props: any) => {
  const { product, spec, parentIndex, index } = props;
  const compareProducts = useSelector(selectCompareProducts);

  const [currentFeature, setCurrentFeature] = React.useState(
    _.find(spec.features, { size: "16002000" }) || spec.features[0]
  );
  const [quantity, decreaseQuantity, increaseQuantity, resetQuantity] =
    useQuantity(1);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const filter = location.search ? queryString.parse(location.search) : {};

  React.useEffect(() => {
    if (filter) {
      if (filter.long && filter.wide) {
        setCurrentFeature(
          _.find(
            spec.features,
            { size: filter.wide.toString() + filter.long.toString() } ||
              spec.features[0]
          )
        );
      }
    } else {
      setCurrentFeature(
        _.find(spec.features, { size: "16002000" } || spec.features[0])
      );
    }
  }, [product]);

  const getDataAddToCart = () => ({
    _id: product.cat_id,
    slug: getEntityForSlug() ? getEntityForSlug().slug : "",
    slug_en: getEntityForSlug() ? getEntityForSlug().slug_en : "",
    code: currentFeature.value,
    disable_buy_button: currentFeature.disable_buy_button,
    disable_buy_button_message: currentFeature.disable_buy_button_message,
    feature: {
      currency: "VNĐ",
      discount_percent: currentFeature.discount_percent,
      feature_id: currentFeature.feature_id,
      price: currentFeature.price,
      price_promotion: currentFeature.price_promotion,
      price_save: currentFeature.price_save,
      //TODO
      product_cat_id: product.cat_id,
      //
      spec: currentFeature.label,
    },
    product_property: {
      [PROPERTY_TYPE.image]: {
        code: PROPERTY_TYPE.image,
        image:
          spec.img_details && spec.img_details.length
            ? spec.img_details[0].path
            : product.img,
        is_use: false,
        label: spec.name,
        position: 3,
        title: "Hoa văn",
        value: product.is_show_only_spec
          ? spec.kde_pro_spec_id
          : spec.kde_pro_spec_id + "|" + spec.kde_pro_id,
      },
    },
    // gift_quantity: 1,
    img:
      spec.img_details && spec.img_details.length
        ? spec.img_details[0].path
        : product.img,
    name: _.find(spec.features, {
      kde_pro_id: parseInt(spec.kde_pro_id),
    }).name,
    // name: product.name,
    // services: prod.services,
    wish: false,
    category_name: product.category_name,
  });

  const handleAddToCart = async () => {
    const _data = getDataAddToCart();

    const addToCartResponse = await dispatch(
      addProductToCart(_data, true, quantity)
    );

    if (!addToCartResponse) {
      NotificationAddToCartSuccess({
        productName: _.find(spec.features, {
          kde_pro_id: parseInt(spec.kde_pro_id),
        }).name,
        productFeature: currentFeature.label,
      });

      let parentNode = document.getElementsByClassName("filter-product-list")[
        parentIndex
      ];

      if (!parentNode) return false;

      return { parentNode, index };
    }
    return false;
  };

  const handleOnChange = (value: any) => {
    const f = _.find(spec.features, { value: value });

    setCurrentFeature(f);
  };

  const getImage = () => {
    let src = "";

    if (Array.isArray(spec.img_details) && spec.img_details.length) {
      src = spec.img_details[0]._id;
    }

    return src;
  };
  const getName = () => {
    let rs = "";
    const feature = _.find(spec.features, {
      kde_pro_id: parseInt(spec.kde_pro_id),
    });

    if (feature) {
      rs = feature.name;
    }

    return rs;
  };

  const getPropertiesCompare = () => {
    const featureObj = {
      label: currentFeature.label,
      value: currentFeature.value,
    };

    const patternObj = {
      label: spec.name,
      value: product.is_show_only_spec
        ? spec.kde_pro_spec_id
        : spec.kde_pro_spec_id + "|" + spec.kde_pro_id,
    };

    return {
      foam: null,
      feature: featureObj,
      desk: null,
      cover: null,
      pattern: patternObj,
    };
  };

  const handleAddToCompare = () => {
    const _data = {
      img:
        spec.img_details && spec.img_details.length
          ? spec.img_details[0].path
          : product.img,
      name: _.find(spec.features, {
        kde_pro_id: parseInt(spec.kde_pro_id),
      }).name,
      price: currentFeature.price,
      price_promotion: currentFeature.price_promotion,
      properties: getPropertiesCompare(),
      gifts: [],
      dataAddToCart: getDataAddToCart(),
    };

    dispatch(addCompareProduct(_data));
  };

  const handleRemoveFromCompare = () => {
    const properties = getPropertiesCompare();

    const index = compareProducts.findIndex((item: any) => {
      let check = false;

      if (
        properties.feature?.value === item.properties?.feature?.value &&
        properties.pattern?.value === item.properties?.pattern?.value
      ) {
        check = true;
      }

      return check;
    });

    dispatch(removeCompareProduct(index));
  };

  const getEntityForSlug = () => {
    if (currentFeature.cat_id_v2 && currentFeature.slug) {
      return currentFeature;
    } else {
      return product;
    }
  };

  const getProductItemProps = () => ({
    productId: currentFeature.cat_id_v2 || product.cat_id,
    productPath: getSlugByLanguage(getEntityForSlug(), i18n.language),
    productSpecCode: product.is_show_only_spec
      ? spec.kde_pro_spec_id
      : spec.kde_pro_spec_id + "|" + spec.kde_pro_id,
    img: getImage(),
    name: getName(),
    featureCode: currentFeature.value,
    pattern_name: spec.name,
    price: currentFeature.price,
    price_promotion: currentFeature.price_promotion,
    discount_percent: currentFeature.discount_percent,
    price_installment: currentFeature.price_installment,
    info_promotion: currentFeature.info_promotion,
    quantity: quantity,
    category_name: product.category_name,
    features: {
      options: spec.features,
      currentValue: currentFeature,
      handleOnChange: handleOnChange,
      is_need_dropdown_features: product.is_need_dropdown_features,
      is_label_dropdown: product.is_label_dropdown,
      is_special_category: product.is_special_category,
      is_hide_thick_dropdown: product.is_hide_thick_dropdown,
      is_normal_dropdown: product.is_normal_dropdown,
    },
    covers: null,
    foams: null,
    desk: null,
    isHaveMoreGift: checkGrandOpeningPromotion(true, "", product.cat_id),
    isNeedCompare: true,
    isInCompareList: checkInCompareList(
      getPropertiesCompare(),
      compareProducts
    ),
    addToCart: handleAddToCart,
    decreaseQuantity: decreaseQuantity,
    increaseQuantity: increaseQuantity,
    resetQuantity: resetQuantity,
    addToCompare: handleAddToCompare,
    removeFromCompare: handleRemoveFromCompare,
    renderWishButton: () => (
      <WishButton {...props} feature={currentFeature} spec={spec} />
    ),
  });

  return <ProductItemComponent {...getProductItemProps()} />;
};

export default FilterProductSpecItem;
